class CnpjConfiavelService
  @$inject = ['genericServiceHelper']

  constructor: (serviceHelper) ->
    serviceHelper(
      url: '/eficiencia-fiscal/cnpj-confiavel/'
      screenId: '#eficiencia-fiscal'
      only: ['getList', 'save']
      service: this
    )

angular.module('eficienciaFiscalModule').service('cnpjConfiavelService', CnpjConfiavelService)
